import { Stack } from "@mui/material";
import { PhoneField } from "@src/appV2/lib/FormFields/PhoneField/PhoneField";
import { Button } from "@src/appV2/redesign/components/Button";
import { LoadingButton } from "@src/appV2/redesign/components/LoadingButton";
import { Illustration, Text } from "@src/appV2/redesign/system/ui-components";
import { useFormContext } from "react-hook-form";

const MODAL_STACK_SPACING = 10;

export interface PhoneFormData {
  phone: string;
}

interface PhoneConfirmationStepContentProps {
  onConfirm: (data: PhoneFormData) => void;
  onBack: () => void;
  isNotifyingRecruiter: boolean;
  source: "banner" | "detail-cta";
}

function getTitle(source: "banner" | "detail-cta"): string {
  if (source === "banner") {
    return "Complete call with Clipboard to apply for jobs";
  }

  return "Complete call with Clipboard to unlock interviews";
}

export function PhoneConfirmationStepContent(props: PhoneConfirmationStepContentProps) {
  const { onConfirm, onBack, isNotifyingRecruiter, source } = props;
  const { handleSubmit } = useFormContext<PhoneFormData>();

  const title = getTitle(source);

  return (
    <Stack spacing={MODAL_STACK_SPACING} alignItems="center" justifyContent="center">
      <Stack spacing={4} alignItems="center" justifyContent="center">
        <Illustration type="phone" />

        <Text variant="h2" textAlign="center">
          {title}
        </Text>
      </Stack>

      <Stack spacing={4} alignSelf="stretch">
        <PhoneField name="phone" showLabel={false} />
      </Stack>

      <Stack spacing={4} alignSelf="stretch">
        <LoadingButton
          fullWidth
          variant="contained"
          size="large"
          isLoading={isNotifyingRecruiter}
          onClick={handleSubmit(onConfirm)}
        >
          Confirm call
        </LoadingButton>

        <Button fullWidth variant="outlined" size="large" onClick={onBack}>
          Back
        </Button>
      </Stack>
    </Stack>
  );
}
